export default __webpack_public_path__ + "static/media/massab_cv.b08d24dc.pdf";